var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "router-nav" },
    [
      _c(
        "span",
        {
          staticClass: "color-primary",
          on: {
            click: function($event) {
              return _vm.$emit("goHome")
            }
          }
        },
        [_c("i", { staticClass: "fas fa-home home-icon" })]
      ),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-chevron-right chevron-icon" }),
      _vm._v(" "),
      _vm._l(_vm.routes, function(route, index) {
        return _c(
          "span",
          { key: route.name || index, staticClass: "router-name" },
          [
            _c(
              "span",
              {
                class: [
                  index === _vm.routes.length - 1
                    ? "color-primary"
                    : "font-weight-500",
                  {
                    "cursor-pointer":
                      route.name && index < _vm.routes.length - 1
                  }
                ],
                on: {
                  click: function($event) {
                    return _vm.navigate(route)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(route.label) + "\n    ")]
            ),
            _vm._v(" "),
            index < _vm.routes.length - 1
              ? _c("i", {
                  staticClass: "fa fa-chevron-right chevron-icon ml-5px"
                })
              : _vm._e()
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e97b935c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e97b935c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/layout/LayoutBases/LayoutAnalise/Nav/Nav.vue
// module id = null
// module chunks = 